'use client'

import { IMapMethods, type IMarker, type ITravelPointQuote } from '@repo/sdk'
import { RefObject, useEffect, useMemo } from 'react'

export const useMap = (
  drops: ITravelPointQuote[],
  refMap: RefObject<IMapMethods | undefined>,
  isLoading?: boolean,
) => {
  const coordinates: false | string[] = useMemo(
    () =>
      drops
        ?.map(data => data.place?.lat && [data.place?.lat, data.place?.lng].join(','))
        .filter(data => data) as string[],
    [drops],
  )

  const markers = useMemo(
    () =>
      drops
        ?.map(
          data =>
            data.place?.lat &&
            data.place?.lng && {
              lat: data.place?.lat,
              lng: data.place?.lng,
            },
        )
        .filter(data => data) as IMarker[],
    [drops],
  )

  const acceptRoutes = useMemo(() => (coordinates ? coordinates.length > 1 : false), [coordinates])

  const coordinatesData = useMemo(() => acceptRoutes && coordinates, [acceptRoutes, coordinates])

  useEffect(() => {
    if (markers && !isLoading) {
      refMap.current?.updateMarker(markers)
    }
  }, [refMap.current, markers, isLoading])

  useEffect(() => {
    if (!isLoading) {
      if (coordinatesData) {
        refMap.current?.updateRoute?.(coordinatesData)
      } else {
        refMap.current?.updateRoute?.(false)
      }
    }
  }, [refMap.current, coordinatesData, isLoading])

  return {
    acceptRoutes,
    coordinates,
    coordinatesData,
    markers,
  }
}
